import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, viewChild } from '@angular/core';
import OptionGroup from '../../../smoothr-web-app-core/models/OptionGroup';
import ArticleOption from '../../../smoothr-web-app-core/models/ArticleOption';
import { DisplayIdentifier } from '../../../smoothr-web-app-core/enums/DisplayIdentifier';
import Article from '../../../smoothr-web-app-core/models/Article';
import { PreorderType } from '../../../smoothr-web-app-core/enums/PreorderType';
import { OrderType } from '../../../smoothr-web-app-core/enums/OrderType';
import { getAvailability } from '../../../smoothr-web-app-core/utils/utils';
import { AppComponent } from 'src/app/app.component';
import ArticleGroup from 'src/smoothr-web-app-core/models/ArticleGroup';
import { DisplayMode } from '../../../smoothr-web-app-core/enums/DisplayMode';

@Component({
	selector: 'app-article-option-group-custom',
	templateUrl: './article-option-group-custom.component.html',
	styleUrls: ['article-option-group-custom.component.scss'],
})
export class ArticleOptionGroupCustomComponent implements OnInit {
	optionGroupValue: OptionGroup;
	@ViewChild('wrapperArticles') wrapperArticles: ElementRef<HTMLElement>;
	@Input() set optionGroup(value: OptionGroup) {
		if (value) {
			value.articles = value.articles.filter(it => !this.isHidden(it) && !it.hidden);
			this.optionGroupValue = value;
		}
	}
	@Input() chooseSizeMode = false;
	@Input() article: Article;
	@Output() selection = new EventEmitter<ArticleOption>();
	@Output() openInfo = new EventEmitter<Article>();

	@Input() preorderType: PreorderType;
	@Input() currency: string;
	@Input() customView: boolean = false;
	@Input() showAllButton = true;
	@Input() filtersValues: string[] = [];
	@Input() articleGroup: ArticleGroup;
	@Input()
	set selected(value: ArticleOption[]) {
		this._selected = value;
	}
	di = DisplayIdentifier;

	private _selected: ArticleOption[] = [];

	constructor() {}

	get selected(): ArticleOption[] {
		return this._selected;
	}

	isVertical(optionGroup: OptionGroup): boolean {
		return !optionGroup?.tags?.find(tag => tag.identifier === 'recircle_bowls');
	}

	ngOnInit() {}

	onAdd(article: Article) {
		if (this.articleGroup) {
			const foundOptions = this.articleGroup.groups.filter(it => it.group === this.optionGroupValue._id);
			const maximumCount = foundOptions.reduce((a, b) => a + b.quantity, 0);
			if (this.optionGroupValue.hasMultiple && this.optionGroupValue.limit >= 2 && this.optionGroupValue.limit <= maximumCount) {
				return;
			}
		}
		console.log('ON ADD', article);
		const articleOption = new ArticleOption();
		articleOption.article = article;
		articleOption.group = this.optionGroupValue._id;
		articleOption.quantity = 1;
		this.selection.emit(articleOption);
	}

	onRemove(article: Article) {
		if (this.articleGroup) {
			const foundOptionsAll = this.articleGroup.groups.filter(it => it.group === this.optionGroupValue._id);

			const foundOptions = this.articleGroup.groups.filter(it => it.article._id === article._id);
			const maximumCount = foundOptionsAll.reduce((a, b) => a + b.quantity, 0);
			maximumCount;
			if (this.optionGroupValue.hasMultiple && this.optionGroupValue.limit >= 2 && this.optionGroupValue.limit <= maximumCount) {
				if (foundOptions.length === 0) {
					return;
				}
			}
		}
		const option = new ArticleOption();
		option.article = article;
		option.quantity = -1;
		option.group = this.optionGroupValue._id;
		this.selection.emit(option);
	}

	count(article: Article) {
		return this.selected.filter(ao => ao.article._id === article._id).reduce((prev, curr) => prev + curr.quantity, 0);
	}

	isHidden(article: Article): boolean {
		return this.preorderType && !getAvailability(article, OrderType.PREORDER, this.preorderType);
	}

	checkIfModifierSelectExist(optionGroup: OptionGroup) {
		return !!(optionGroup?.tags ?? []).find(it => it?.identifier === 'modifier_select');
	}
	checkIfModifierRemoveExist(optionGroup: OptionGroup) {
		return !!(optionGroup?.tags ?? []).find(it => it?.identifier === 'modifier_remove');
	}

	onScroll() {}

	ifFilterVisible(article: Article) {
		if (this.filtersValues.length === 0) {
			return false;
		}
		let articleFilter = false;
		this.filtersValues.forEach(it => {
			if (it == 'meat') {
				if (
					article?.compound?.features &&
					(article.compound.features['beef'] === true ||
						article.compound.features['chicken'] === true ||
						article.compound.features['pork'] === true)
				) {
					articleFilter = true;
				}
			}
			if (article?.compound?.features && article.compound.features[it] && article.compound.features[it] == true) {
				articleFilter = true;
			}
			if (article?.compound?.allergens && it === 'gluten' && article.compound.allergens['cerealsContainingGluten'] == true) {
				articleFilter = true;
			}
			if (article?.compound?.allergens && it === 'peanut' && article.compound.allergens['peanutsAndProductsThereof'] == true) {
				articleFilter = true;
			}
			if (article?.compound?.allergens && it === 'lactose' && article.compound.allergens['milkAndProductsThereof'] == true) {
				articleFilter = true;
			}
		});
		return articleFilter;
	}

	openInfoEmit(article: Article) {
		this.openInfo.emit(article);
	}

	protected readonly DisplayMode = DisplayMode;
}
